
export const DEFAULT_CREATE_REQUIREMENT_PRE_OUT_LOCATION_TYPES = [1];

export const buildCreateRequirementPreOutLocationTypes = (
  locationTypes: number[],
): number[] => locationTypes;

export const hasCreateRequirementPreOutLocationTypes = (
  locationTypes: number[],
): boolean => locationTypes.length > 0;
